import Column from "@amzn/meridian/column";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AddEditRealProperty } from "../../components/edit-property/AddEditRealProperty";
import Page from "../../components/page/Page";
import { useBreadcrumbs } from "../../features/breadcrumbs/hooks";
import PageHeader from "../../features/page-header/PageHeader";
import Link from "@amzn/meridian/link";
import { TangoDataSheet } from "../../components/tango-data/TangoDataSheet";
import { useGetRealPropertyDetailsQuery } from "../../endpoints/getRealProperty";
import Row from "@amzn/meridian/row";

export const CreateEditPropertyPage: React.FC = () => {
    const { propertyId } = useParams();
    const title = propertyId ? "Edit property" : "Create property";
    const location = useLocation();
    const { data: realPropertyData } = useGetRealPropertyDetailsQuery({
        artifactId: propertyId,
        businessUseCase: "SMART",
    });
    const [open, setOpen] = useState(false);

    const { updateBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        updateBreadcrumbs(
            [
                { text: "Home", href: "/" },
                propertyId
                    ? {
                          text: _.truncate(location.state?.propertyNumber, { length: 15 }),
                          href: `/property-details/${propertyId}`,
                      }
                    : undefined,
                {
                    text: title,
                    href: "",
                },
            ].filter(Boolean)
        );
    }, []);

    return (
        <Page type="form" title={title} hasBreadcrumbs={true}>
            <PageHeader />
            {title === "Edit property" ? (
                <>
                    <Link
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        Show Tango data
                    </Link>
                </>
            ) : (
                <></>
            )}
            <Row alignmentVertical={"top"}>
                <AddEditRealProperty />
                <TangoDataSheet
                    data={realPropertyData}
                    open={open}
                    setOpen={setOpen}
                    sheetType={"push"}
                    sheetSide={"end"}
                    columnWidth={"50%"}
                    boxHeight={"100%"}
                    rowHeight={"80px"}
                />
            </Row>
            <Column overflowY={"scroll"} maxHeight={"300px"} backgroundColor={"pink"}></Column>
        </Page>
    );
};

export default CreateEditPropertyPage;
